import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import authReducer from './auth/authSlice';
import alertReducer from './alert/alertSlice';
import folderReducer from './folder/folderSlice';
import todoReducer from './todo/todoSlice';
import opentabReducer from './opentab/opentabSlice';
import shortcutReducer from './shortcut/shortcutSlice';
const store = configureStore({
    reducer: {
        auth: authReducer,
        alert: alertReducer,
        folder: folderReducer,
        todo: todoReducer,
        opentab: opentabReducer,
        shortcut:shortcutReducer
    },
});

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppDispatch = () => useDispatch();
export default store;